import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import tw from "twin.macro"
import { socialMedia } from "@config"
import { Icon } from "@components/icons"

const StyledSocial = styled.div`
  ${tw`flex`}
  ${props =>
    props.position === "hero" &&
    tw`hidden md:flex absolute bottom-12 md:w-full md:justify-end `}
`

const StyledSocialList = styled.ul`
  ${tw`flex gap-10 items-center list-none p-0 pr-4 xl:pr-0`}
  & {
    @media (min-width: 768px) {
      :before {
        content: "";
        height: 1px;
        ${tw` block w-full bg-suvaGrey absolute -left-1/2 xl:-left-1/4 rounded-lg`};
        ${props => props.position !== "hero" && tw`hidden`}
      }
    }

    li {
      a {
        ${tw`text-suvaGrey`}
        svg {
          ${tw`transition-colors`}
        }
        :hover,
        :focus {
          svg {
            ${tw`text-blue-400`}
          }
        }
      }
    }
  }
`

const Social = ({ position }) => (
  <StyledSocial position={position}>
    <StyledSocialList position={position}>
      {socialMedia &&
        socialMedia.map(({ name, url }, i) => (
          <li key={i}>
            <a href={url} aria-label={name} target="_blank">
              <Icon name={name} />
            </a>
          </li>
        ))}
    </StyledSocialList>
  </StyledSocial>
)

Social.propTypes = {
  position: PropTypes.string.isRequired,
}

export default Social
